import React from 'react';
import { useTheme } from '../../contexts/ThemeContext';
import { Icon } from '../ui/Icon';
import styles from './ThemeToggle.module.css';

const ThemeToggle = ({ variant = 'icon' }) => {
  const { theme, toggleTheme, isDark } = useTheme();

  if (variant === 'button') {
    // Button variant for sidebar
    return (
      <button
        className={styles.themeToggleButton}
        onClick={toggleTheme}
        title={`Switch to ${isDark ? 'light' : 'dark'} mode`}
        aria-label={`Switch to ${isDark ? 'light' : 'dark'} mode`}
      >
        <div className={styles.iconWrapper}>
          <Icon name={isDark ? 'sun' : 'moon'} size={18} className={styles.icon} />
        </div>
        <span className={styles.label}>
          {isDark ? 'Light Mode' : 'Dark Mode'}
        </span>
      </button>
    );
  }

  // Icon-only variant for header
  return (
    <button
      className={styles.themeToggleIcon}
      onClick={toggleTheme}
      title={`Switch to ${isDark ? 'light' : 'dark'} mode`}
      aria-label={`Switch to ${isDark ? 'light' : 'dark'} mode`}
    >
      <Icon name={isDark ? 'sun' : 'moon'} size={20} />
    </button>
  );
};

export default ThemeToggle;
